module.exports = __webpack_public_path__ + "img/scgexpress_charge_logo.c8859147.png";